export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/prebid-stack/non-consent-traffic-monetization' as const
